"use strict";

var _regeneratorRuntime = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _createClass = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PacketInterface = exports.PacketResponse = void 0;

var logger_1 = require("./logger");

var uuid_1 = require("uuid");

var twilsockerror_1 = require("./error/twilsockerror");

var twilsockreplyerror_1 = require("./error/twilsockreplyerror");

var parser_1 = require("./parser");

var Messages = require("./protocol/messages");

var metadata_1 = require("./metadata");

var REQUEST_TIMEOUT = 30000;

function isHttpSuccess(code) {
  return code >= 200 && code < 300;
}
/**
 * Makes sure that body is properly stringified
 */


function preparePayload(payload) {
  switch (typeof payload) {
    case 'undefined':
      return '';

    case 'object':
      return JSON.stringify(payload);

    default:
      return payload;
  }
}

var PacketRequest = function PacketRequest() {
  _classCallCheck(this, PacketRequest);
};

var PacketResponse = function PacketResponse() {
  _classCallCheck(this, PacketResponse);
};

exports.PacketResponse = PacketResponse;

var PacketInterface = /*#__PURE__*/function () {
  function PacketInterface(channel, config) {
    var _this = this;

    _classCallCheck(this, PacketInterface);

    this.config = config;
    this.activeRequests = new Map();
    this.channel = channel;
    this.channel.on('reply', function (reply) {
      return _this.processReply(reply);
    });
    this.channel.on('disconnected', function () {
      _this.activeRequests.forEach(function (descriptor) {
        clearTimeout(descriptor.timeout);
        descriptor.reject(new twilsockerror_1.TwilsockError('disconnected'));
      });

      _this.activeRequests.clear();
    });
  }

  _createClass(PacketInterface, [{
    key: "processReply",
    value: function processReply(reply) {
      var request = this.activeRequests.get(reply.id);

      if (request) {
        clearTimeout(request.timeout);
        this.activeRequests.delete(reply.id);

        if (!isHttpSuccess(reply.status.code)) {
          request.reject(new twilsockreplyerror_1.TwilsockReplyError('Transport failure: ' + reply.status.status, reply));
          logger_1.log.trace('message rejected');
        } else {
          request.resolve(reply);
        }
      }
    }
  }, {
    key: "storeRequest",
    value: function storeRequest(id, resolve, reject) {
      var requestDescriptor = {
        resolve: resolve,
        reject: reject,
        timeout: setTimeout(function () {
          logger_1.log.trace('request', id, 'is timed out');
          reject(new twilsockerror_1.TwilsockError('Twilsock: request timeout: ' + id));
        }, REQUEST_TIMEOUT)
      };
      this.activeRequests.set(id, requestDescriptor);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.activeRequests.forEach(function (descriptor) {
        clearTimeout(descriptor.timeout);
        descriptor.reject(new twilsockerror_1.TwilsockError('Twilsock: request cancelled by user'));
      });
      this.activeRequests.clear();
    }
  }, {
    key: "sendInit",
    value: function () {
      var _sendInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var metadata, message, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger_1.log.trace('sendInit');
                metadata = metadata_1.Metadata.getMetadata(this.config);
                message = new Messages.Init(this.config.token, this.config.continuationToken, metadata, this.config.initRegistrations, this.config.tweaks);
                _context.next = 5;
                return this.sendWithReply(message);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", new Messages.InitReply(response.id, response.header.continuation_token, response.header.continuation_token_status, response.header.offline_storage, response.header.init_registrations, response.header.debug_info, new Set(response.header.capabilities)));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendInit() {
        return _sendInit.apply(this, arguments);
      }

      return sendInit;
    }()
  }, {
    key: "sendClose",
    value: function sendClose() {
      var message = new Messages.Close(); //@todo send telemetry AnyEventsIncludingUnfinished

      this.send(message);
    }
  }, {
    key: "sendWithReply",
    value: function sendWithReply(header, payload) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var id = _this2.send(header, payload);

        _this2.storeRequest(id, resolve, reject);
      });
    }
  }, {
    key: "send",
    value: function send(header, payload) {
      header.id = header.id || "TM".concat(uuid_1.v4());
      var message = parser_1.Parser.createPacket(header, preparePayload(payload));

      try {
        this.channel.send(message);
        return header.id;
      } catch (e) {
        logger_1.log.debug('failed to send ', header, e);
        logger_1.log.trace(e.stack);
        throw e;
      }
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.channel.isConnected;
    }
  }]);

  return PacketInterface;
}();

exports.PacketInterface = PacketInterface;